import { Facade } from '@niknevis/vue-modules'
import HTTPService from '@/modules/shared/helpers/http/services/http.service'

export class HTTP extends Facade<HTTPService>() {
  static getFacadeAccessor() {
    return HTTPService
  }
}
